// base
export * from "./logo";
export * from "./code";
export * from "./search";
export * from "./docs-title";
export * from "./code-preview";
export * from "./color-palette";
export * from "./framework-card";

// layout
export * from "./layout/navbar";
export * from "./layout/footer";
export * from "./layout/sidenav";
export * from "./layout/page-map";
export * from "./layout/docs-navbar";

// icons
export * from "./icons/astro";
export * from "./icons/cra";
export * from "./icons/gatsby";
export * from "./icons/next";
export * from "./icons/remix";
export * from "./icons/vite";

// sections
export * from "./sections/pro";
export * from "./sections/hero";
export * from "./sections/figma";
export * from "./sections/features";
export * from "./sections/community";
export * from "./sections/subscribe";
export * from "./sections/components";
export * from "./sections/integrations";
